import styled from "styled-components"

/** Outlined dashed style — mid-edge "+" is the secondary action for
 *  inserting a node between two existing ones. Subtle on purpose so it
 *  doesn't compete with the solid terminal add button. */
export const AddButton = styled.button`
  position: absolute;
  pointer-events: all;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 0.15rem dashed ${(p) => p.theme.colors.greyLight};
  background: ${(p) => p.theme.colors.white};
  color: ${(p) => p.theme.colors.greyDark};
  font-size: 1.3rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 0.05rem 0.15rem rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease;
  padding: 0;
  opacity: 0.85;

  &:hover {
    border-style: solid;
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.turquoiseDark};
    opacity: 1;
    box-shadow: 0 0.15rem 0.4rem rgba(0, 0, 0, 0.12);
  }
`
